import { render } from "./SubjectEdit.vue?vue&type=template&id=c1b107b0"
import script from "./SubjectEdit.vue?vue&type=script&lang=js"
export * from "./SubjectEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__